import React from 'react';
import { Pressable, View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Unicon from '../Unicon';
import InlineHelpIcon from './InlineHelpIcon';

const Checkbox = ({
    checked = false,
    onChange,
    disabled = false,
    size = 20,
    indeterminate = false,
    label,
    helpText,
    required = false,
    testID,
}) => {
    const isActive = checked || indeterminate;

    const toggle = () => {
        if (!disabled) {
            onChange?.(!checked);
        }
    };

    const checkbox = (
        <View style={styles.container(size, disabled, isActive)}>
            {isActive && (
                <Unicon
                    name={indeterminate ? "remove" : "checkmark"}
                    size={size - 4}
                    colorVariant="onPrimary"
                />
            )}
        </View>
    );

    if (!label && !helpText) {
        return (
            <Pressable onPress={toggle} disabled={disabled} style={[styles.pressable, styles.interactive(disabled, size)]} hitSlop={8} testID={testID}>
                {checkbox}
            </Pressable>
        );
    }

    return (
        <Pressable onPress={toggle} disabled={disabled} style={[styles.row, styles.interactive(disabled, size)]} hitSlop={8} testID={testID} accessibilityRole="checkbox" accessibilityState={{ checked, disabled }}>
            {checkbox}
            {label && (
                <View style={styles.labelWrap}>
                    <Text style={styles.label(disabled)}>
                        {label}
                        {required && <Text style={styles.required}>*</Text>}
                        {helpText && <InlineHelpIcon text={helpText} size={16} colorVariant="textTertiary" />}
                    </Text>
                </View>
            )}
        </Pressable>
    );
};

const styles = StyleSheet.create((theme) => ({
    pressable: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.spacing.sm,
    },
    interactive: (disabled, size) => ({
        borderRadius: Math.max(4, size * 0.2),
        outlineStyle: 'none',
        _web: {
            cursor: disabled ? 'not-allowed' : 'pointer',
            transition: 'box-shadow 0.15s ease',
            _focus: {
                boxShadow: disabled ? 'none' : `0 0 0 3px ${theme.colors.primary}26`,
            },
        },
    }),
    container: (size, disabled, isActive) => ({
        width: size,
        height: size,
        borderRadius: Math.max(4, size * 0.2),
        borderWidth: 1,
        borderColor: isActive ? theme.colors.primary : theme.colors.outline,
        backgroundColor: isActive ? theme.colors.primary : theme.colors.surface,
        alignItems: 'center',
        justifyContent: 'center',
        opacity: disabled ? 0.5 : 1,
        _web: {
            transition: 'border-color 0.15s ease',
            _hover: {
                borderColor: disabled || isActive ? (isActive ? theme.colors.primary : theme.colors.outline) : theme.colors.primary,
            },
        },
    }),
    label: (disabled) => ({
        fontSize: theme.typography.body,
        fontFamily: theme.fonts.body,
        color: disabled ? theme.colors.textTertiary : theme.colors.text,
        flexShrink: 1,
    }),
    labelWrap: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
        flexShrink: 1,
    },
    required: {
        color: theme.colors.error,
        fontSize: 14,
        fontFamily: theme.fonts.body,
        marginLeft: -2,
    },
}));

export default Checkbox;
